/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SliderComponent as Éµa} from './src/app/slider/slider.component';